// Translate
import { Trans, useTrans } from "@/i18n"

// UI
import { cn } from "@/lib/utils"
import { Heading } from "@/components/Typography"
import { Button } from "@/components/Button"
import { Disclaimer } from "@/components/Disclaimer"
import { Card } from "@/components/Card"
import { ChangePassword } from "@/components/forms/ChangePassword"

// Environment variables
import { AUTH_MFA_URL } from "@/lib/env"

/**
 * ProfileAccount
 * @returns
 */
export const ProfileAccount = () => {
	const t = useTrans("profile")

	return (
		<>
			<title>
				{t("common:web.title", {
					page: t("profile:account_settings.title"),
				})}
			</title>

			<Disclaimer
				className="mb-3"
				title={t("profile:security.title")}
				message={
					<p>
						{t("profile:security.banner.copy")}
						<br />
						<br />
						<Trans
							i18nKey="profile:security.banner.link"
							components={{
								u: <u />,
								strong: <strong />,
							}}
						/>
						<br /> <br />
						<a
							href={AUTH_MFA_URL}
							target="_blank"
							rel="noopener noreferrer"
							className={cn(
								"text-gray-500 hover:text-gray-700",
								"text-sm font-medium whitespace-nowrap",
							)}
						>
							<span>
								{t("profile:security.banner.link.text")}
							</span>
						</a>
					</p>
				}
			/>

			<ChangePassword />

			<Card className="mt-8">
				<Heading
					as="h2"
					styleAs="h5"
					className="mb-3 text-gray-600 sm:truncate"
				>
					{t("profile:account_deletion.title")}
				</Heading>
				<p className="text-sm text-gray-500">
					{t("profile:account_deletion.copy")}
					<br />
					<br />
					<strong>
						{t("profile:account_deletion.no-investments.header")}
					</strong>
					<br />
					{t("profile:account_deletion.no-investments.copy")}
					<br />
					<br />
					<strong>
						{t("profile:account_deletion.open-investments.header")}
					</strong>
					<br />
					<Trans
						i18nKey="profile:account_deletion.open-investments.copy"
						components={{
							a: (
								<a //oxlint-disable-line jsx-a11y/anchor-has-content
									href="mailto:info@zonhub.com"
									className="text-secondary-700 font-medium"
								/>
							),
						}}
					/>
					<br />
					<br />
					{t("profile:account_deletion.warning")} <br />
				</p>

				{/** Delete account button */}
				<a
					href={`mailto:info@zonhub.com?subject=${encodeURIComponent(
						t("profile:account_deletion.button"),
					)}&body=${encodeURIComponent(
						t("profile:account_deletion.email.body"),
					)}`}
				>
					<Button className="mt-4">
						{t("profile:account_deletion.button")}
					</Button>
				</a>
			</Card>
		</>
	)
}
